module.exports = __webpack_public_path__ + "static/merch5Back-6c42a081f275d53762effab542e38df5.png";